import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { StandardUpgradeModalProps } from './StandardUpgradeModal.tsx';

export const StandardUpgradeModalLoadable: LoadableType<StandardUpgradeModalProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-standard-upgrade-modal" */ './StandardUpgradeModal.tsx'
			)
		).StandardUpgradeModal,
});
